import { BagHoldIcon, BagPersonalItemIcon, CabinTrolleyIcon, CancellationPartiallyRefundableIcon, FastTrackIcon, FoodIcon, HealthInsuranceIcon, PhoneCheckmarkIcon, PlaneTicketReturnIcon, SeatRegularIcon } from "@bookingcom/bui-assets-react/streamline/index.js";
export const includedBaggageIcons = {
    PERSONAL_ITEM: BagPersonalItemIcon,
    HAND: CabinTrolleyIcon,
    CHECKED_IN: BagHoldIcon
};
export const productIcons = {
    checkedInBaggage: BagHoldIcon,
    specialBag: BagHoldIcon,
    specialBags: BagHoldIcon,
    cabinBaggage: CabinTrolleyIcon,
    cabinBaggagePerTraveller: CabinTrolleyIcon,
    personalItem: BagPersonalItemIcon,
    flexibleTicket: PlaneTicketReturnIcon,
    mobileTravelPlan: PhoneCheckmarkIcon,
    travelInsurance: HealthInsuranceIcon,
    mealChoice: FoodIcon,
    mealPreference: FoodIcon,
    seatingBesides: SeatRegularIcon,
    seatingPreference: SeatRegularIcon,
    seatMapSelection: SeatRegularIcon,
    seatMap: SeatRegularIcon,
    cancelForAnyReason: CancellationPartiallyRefundableIcon,
    fastTrack: FastTrackIcon
};
